<template>
  <div style="position: fixed;z-index: 100000;display: none">
    <div class="arrow_box no-print animated infinite onboarding_animate"></div>
  </div>
</template>

<script>
  export default {
    mounted () {
      if (window.location.href.indexOf('intro=true') > -1) {
        const el = document.querySelector('.js-onboarding-arrow-planning').getBoundingClientRect()
        this.$el.style.top = el.bottom + 0 + 'px'
        this.$el.style.left = el.left + ((el.width / 2) - 20) + 'px'
        this.$el.style.display = 'block'
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .arrow_box {
    display: inline-block;
    height: 40px;
    width: 40px;
    position: relative;
    background: #fc5f45;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  }

  .arrow_box:after, .arrow_box:before {
    top: -10px;
    left: 5px;
    right: 0;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:before {
    border-bottom-color: #fc5f45;
    border-width: 0px 15px 20px;
    border-radius: 4px 4px 0 0;
  }

  @keyframes pulseTop {
    0% {
      transform: translateY(50%);
    }
    50% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(50%);
    }
  }

  .onboarding_animate {
    animation-name: pulseTop;
  }

</style>



// WEBPACK FOOTER //
// arrow.vue?7c3028d0